import React, { useEffect } from 'react'
import { useWindowDimensions } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { B2, BTN_SM, Button, Icon } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { i18n } from '@zet/localization'
import { ModalComponentProp } from 'react-native-modalfy'

import { ModalStackParams } from '../modalConfig'

type Props = ModalComponentProp<
  ModalStackParams,
  void,
  'NoRequestedDataFoundModal'
>

export default function NoRequestedDataFoundModal({
  modal: { closeModal, getParam },
}: Props) {
  const { width } = useWindowDimensions()
  const message = getParam('message', 'Requested data not found')

  useEffect(() => {
    publishEvent('screen_view', { screen_name: 'NoRequestedDataFoundModal' })
  }, [])
  return (
    <Stack
      className="items-center rounded bg-white p-3"
      style={{ width: width - 32 }}
    >
      <Icon type="Analysis" size={100} className="ml-4 mt-4 self-center" />
      <B2 className="text-grays-60 mb-4">{message}</B2>
      <Button outlined fullWidth onPress={closeModal}>
        <BTN_SM className="text-primary-100">{i18n.t('gotIt')}</BTN_SM>
      </Button>
    </Stack>
  )
}
